import { FC, useState, type JSX } from 'react';
import { EventHistoryView } from './event-history-view';
import { MobileTabSelection } from './event-history.types';

interface Props {
  isBottomDrawerOpen?: boolean;
  isDrawerOpen: boolean;
  renderBottomDrawerContent: () => JSX.Element;
  renderHistoryContent: (mobileTabSelection: MobileTabSelection) => JSX.Element;
  renderRightDrawerContent?: () => JSX.Element;
  renderTopDrawerContent: () => JSX.Element;
  setIsTransitioning: (isTransitioning: boolean) => void;
}

export const EventHistory: FC<Props> = ({
  isBottomDrawerOpen,
  isDrawerOpen,
  renderBottomDrawerContent,
  renderHistoryContent,
  renderRightDrawerContent,
  renderTopDrawerContent,
  setIsTransitioning,
}): JSX.Element => {
  const [mobileTabSelection, setMobileTabSelection] = useState<MobileTabSelection>(MobileTabSelection.TOP);

  return (
    <EventHistoryView
      isBottomDrawerOpen={isBottomDrawerOpen}
      isDrawerOpen={isDrawerOpen}
      mobileTabSelection={mobileTabSelection}
      renderBottomDrawerContent={renderBottomDrawerContent}
      renderHistoryContent={renderHistoryContent}
      renderRightDrawerContent={renderRightDrawerContent}
      renderTopDrawerContent={renderTopDrawerContent}
      setIsTransitioning={setIsTransitioning}
      setMobileTabSelection={setMobileTabSelection}
    />
  );
};
